<template>
  <v-card id="container"> 
    <div>
      <v-layout>
        <v-flex>
          <h1>INSTRUCCIÓN DE RIEGO DIARIO</h1>
          <br>
          <hr>
        </v-flex>
      </v-layout>
      <br>
      <v-layout row wrap>
        <v-flex xs12 sm12 md3 lg3>
          <v-layout row wrap>
            <v-flex class="text-md-center" xs12 sm12 md4 lg4>
              <h4>Rancho</h4>
            </v-flex>
            <v-flex xs1 sm1 md1 lg1>
              <v-select
                v-model="select"
                :items="projects"
                label="Rancho"
                outline
                class="dropdown prompt"
                @change="selectSubProject"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm12 md4 lg4 >
          <v-layout row wrap>
            <v-flex class="text-md-center"  xs12 sm12 md3 lg3>
              <h4>Hora Inicial de Riego</h4>
            </v-flex>
            <v-flex xs1 sm1 md1 lg1 class="prompt">
              <input class="form-control control" type="text" id="myTime" step="1" v-model="hora">
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm12 md4 lg4 class="text-md-center">
          <v-btn v-if="select" large color="success light-1"  @click="open()">
            <i class="fas fa-table"> </i>
            VER INSTRUCCIÓN
          </v-btn>
        </v-flex>
      </v-layout>
      <br>
      <v-layout>
        <v-flex v-if="select">
          <v-layout row wrap>
            <v-flex>
              <h2>Sectores de Riego #{{this.sectors.length}}</h2>
            </v-flex>
            <v-flex>
              <v-btn type='button' small class="btn btn-info blue add" @click="addNewSector">
                <i class="fas fa-plus-circle"> </i>
                Sector
              </v-btn>
            </v-flex>
          </v-layout>

          <table>
          <v-layout >
            <v-flex lg12 md12 sm12 xs12>
              <thead>
                <tr>
                  <th class="head trashIconContainer"></th>
                  <th class="head text-xs-center hide">No.</th>
                  <th class="head text-xs-center">Q Riego</th>
                  <th class="head text-xs-center">Nom.</th>
                  <th class="head text-xs-center">ml Riego</th>
                  <th class="head text-xs-center">CE</th>
                  <th class="head text-xs-center">pH</th>
                </tr>
              </thead>
            </v-flex>
            </v-layout>
              
            <v-layout>
              <v-flex>
                <tr v-for="(sector, k) in sectors" :key="k">
                  <td scope="row" class="trashIconContainer" >
                    <i class="fas fa-trash-alt" @click="deleteRowSector(k, sector)"></i>
                  </td>
                  <td class="tablebox hide">
                    <input class="form-control disable text-xs-center" disabled type="text" v-model="sector.index"/>
                  </td>
                  <td>
                    <input class="form-control" type="text" v-model="sector.sector" @change="calcTotal"/>
                  </td>
                  <td>
                    <input class="form-control" type="text" v-model="sector.NoPulse" @change="calcTotal"/>
                  </td>
                  <td>
                    <input class="form-control" type="text" v-model="sector.mlRiego" @change="calcTotal"/>
                  </td>
                  <td>
                    <input class="form-control" type="text" v-model="sector.CE" @change="calcTotal"/>
                  </td>
                  <td>
                    <input class="form-control" type="text" v-model="sector.pH" @change="calcTotal"/>
                  </td>
                </tr>
              </v-flex>
            </v-layout>  
          </table>
          <br>


        </v-flex>

        <v-flex v-if="select">
          <v-layout row wrap>
            <v-flex>
              <h2>Pulsos #{{this.instructions.length}}</h2>
            </v-flex>
            <v-flex>
              <v-btn type='button' small class="btn btn-info blue add" @click="addNewRow">
                <i class="fas fa-plus-circle"> </i>
                Pulso
              </v-btn>
            </v-flex>
          </v-layout>
          <table>
          <v-layout >
            <v-flex lg12 md12 sm12 xs12>
              <thead>
                <tr>
                  <th class="head trashIconContainer"></th>
                  <th class="head text-xs-center">No.</th>
                  <th class="head text-xs-center">Porcentaje</th>
                  <th class="head text-xs-center">Esperar</th>
                </tr>
              </thead>
            </v-flex>
            </v-layout>
              
            <v-layout>
              <v-flex>
                <tr v-for="(instruction, k) in instructions" :key="k">
                  <td scope="row" class="trashIconContainer" >
                      <i class="fas fa-trash-alt" @click="deleteRow(k, instruction)"></i>
                  </td>
                  <td class="tablebox">
                    <input class="form-control disable text-xs-center" disabled type="text" v-model="instruction.index" />
                  </td>
                  <td>
                    <input class="form-control" type="text" v-model="instruction.pulso" @change="calcTotal"/>
                  </td>
                  <td>
                    <input class="form-control" type="text" v-model="instruction.tiempo" @change="calcTotal"/>
                  </td>
                </tr>
                <template v-if="instructions.length > 0">
                  <tr>
                    <td></td>
                    <td>Total</td>
                    <td>{{Math.floor(total)}} %</td>
                  </tr>
                </template>
              </v-flex>
            </v-layout>  
          </table>
          <br>
        </v-flex>
      </v-layout>
      <br>

      
      <v-dialog v-model="dialog" persistent max-width="1300">
        <v-card id="container2">
          <v-card-text>
            <v-layout>
              <v-flex xs12 sm12 md6 lg6 >
                <h1>{{select}}</h1>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6 class="text-md-right">
                <h3>INSTRUCCIÓN DEL DIA</h3>
                <h4>{{new Date().toLocaleDateString('en-GB')}}</h4>
              </v-flex>
            </v-layout>
            <hr>
            <br>
          <v-layout row>
            <v-flex>                 
              <v-data-table
              v-if="headers2"
                hide-actions
                disable-initial-sort
                :headers="headers2"
                :items="sectors"
                :pagination.sync="pagination"
                class="elevation-1"
              >
                <template v-slot:items="props">
                  <td>
                    <v-textarea  rows="1" hide-details class="form-control text" type="text" v-model="props.item.comments" style="margin-top:0px!important;"></v-textarea>
                  </td>
                    <td>{{ props.item.suggestion }}</td>
                  <td>{{ props.item.mlRiego }}</td>
                  <td>{{ props.item.sector }}</td>
                  <td>{{ props.item.NoPulse }}</td>
                  <td>{{ props.item.CE }}</td>
                  <td>{{ props.item.pH }}</td>
                  <td>{{ props.item.totalMin }}</td>

                  <template v-for="(instruction, index) in instructions">
                    <td :key='index'>{{props.item[`pulso${index + 1}`]}}</td>
                  </template>
                </template>
              </v-data-table>
              <!-- TIME TABLE -->
              <v-data-table
              v-if="headers2"
                hide-actions
                disable-initial-sort
                :headers="headers2"
                :items="items"
                :pagination.sync="pagination"
                class="elevation-1 hidden"
              >
                <template v-slot:items="props">
                  <td>
                    <v-textarea  rows="2" box hide-details class="form-control text" type="text" v-model="props.item.comments" ></v-textarea>
                  </td>
                    <td>{{ props.item.suggestion }}</td>
                  <td>{{ props.item.mlRiego }}</td>
                  <td>{{ props.item.sector }}</td>
                  <td>{{ props.item.NoPulse }}</td>
                  <td>{{ props.item.CE }}</td>
                  <td>{{ props.item.pH }}</td>
                  <td class="show">Hora Inicio</td>
                  <template v-for="(instruction, index) in instructions">
                    <td :key='index' class="timeInfo">{{ new Date(pulsosTime[`${index }`]).toLocaleTimeString('en-US').replace(/[a-zA-Z]/g, '')}}</td>
                  </template>
                </template>
              </v-data-table>
              <!-- TOTAL PULSE TIME -->
              <v-data-table
              v-if="headers2"
                hide-actions
                disable-initial-sort
                :headers="headers2"
                :items="items"
                :pagination.sync="pagination"
                class="elevation-1 hidden"
              >
                <template v-slot:items="props">
                  <td>
                    <v-textarea  rows="1" box hide-details class="form-control text" type="text" v-model="props.item.comments" ></v-textarea>
                  </td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class="show">Hora Final</td>

                  <template v-for="(instruction, index) in instructions">
                    <!-- <td :key='index' class="totalTimeInfo">{{ new Date(pulsosTime2[`${index }`]).toLocaleTimeString('en-US')}}</td> -->
                    <td :key='index' class="totalTimeInfo">{{ calcTime(new Date(pulsosTime2[`${index }`]), instruction.tiempo).replace(/[a-zA-Z]/g, '')}}</td>
                  </template>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          </v-card-text>
          <br>
          <v-card-actions>
            <v-btn color="success" style="margin-right:10px !important;"  @click="save">
              <i class="fas fa-file-upload"></i>
              Guardar
            </v-btn>
            <v-btn  @click="close" color="blue">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

  </div> 
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      arr: [],
      dialog: false,
      rancho: '',
      hora: '10:00:00',
      pulso: 100,
      total: 100,
      foo: '',
      select: '',
      instructions: [
      ],
      sectors: [
      ],
      projects:[
        'Andromeda',
        'Aquila',
        'Aquila Q2',
        'Argus'
      ],
      items: [1],
      pulsos: [],
      pulsosTime: [],
      pulsosTime2: [],
      headers2: [],
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
      },
    }
  },
  watch: {
    instructions: function() {
      this.calcTotal()
    }

  },
  beforeCreate() {
    // this.new()
  },
  methods: {
    selectSubProject() {
      // alert(this.select)
      this.new()
    },
    new() {
      let payload = {project: this.select}
      this.$axios.get(`/api/IrrigationInstruction/${payload.project}`)
      .then(response => {
        this.sectors = response.data
        console.log("resp", this.sectors)
        let date = new Date(this.sectors[0].horaInicio)
        let hour = (date.getHours()<10?'0':'') + date.getHours() 
        let minutes = (date.getMinutes()<10?'0':'') + date.getMinutes() 
        let seconds = (date.getSeconds()<10?'0':'') + date.getSeconds() 

        console.log(hour)
        console.log(minutes)
        console.log(seconds)

        this.hora = `${hour}:${minutes}:${seconds}`

        console.log(this.hora)
      })
      .catch(e => {
        // console.log(e);
      });
      this.$axios.get(`/api/PulseInstruction/${payload.project}`)
      .then(response => {
        // console.log("resp", response)
        this.instructions = response.data
      })
      .catch(e => {
        // console.log(e);
      });
    },
    open() {
      this.headers2 =  [
        { text: 'Comentarios', value: 'comentarios' },
        { text: 'Sugerencias', value: 'sugerencias' },
        { text: 'mL Riego', value: 'mlRiego' },
        { text: 'Q Riego', value: 'sector' },
        { text: 'No Pulso', value: 'NoPulso' },
        { text: 'CE', value: 'CE' },
        { text: 'pH', value: 'pH' },
        { text: 'Min', value: 'totalMin' },
      ]
      this.dialog = true
      this.foo = this.hora
      this.pulsosTime = []
      this.pulsosTime2 = []

       this.sectors.forEach(element => {
        let counter = 1
        let totalMin = 0
        this.instructions.forEach(e => {
          let decimalTimeString = ((( e.pulso * element.mlRiego ) / 100) / 66.66)
          totalMin += decimalTimeString
          let res = this.minTommss(decimalTimeString)
          element[`pulso${counter}`] = res

          let n = new Date(0,0);
          n.setSeconds(+decimalTimeString * 60 * 60);
          let chuy = n.toTimeString().slice(0, 8)
          chuy = chuy.toString()
          chuy = chuy.split(":")
          let newChuy = chuy[0] + "." + chuy[1]
          // console.log(newChuy)

          if(this.pulsos[(counter - 1)]) {
            this.pulsos[(counter - 1)] += parseFloat(decimalTimeString)
          } else {
            this.pulsos[(counter - 1)] = parseFloat(decimalTimeString)
          }
          counter++
        });
        element.totalMin = this.minTommss(totalMin)

        if (typeof this.foo === 'string') {
          let test = this.foo.split(":")
          let hour = parseInt(test[0])
          let minutes = parseInt(test[1])
          let seconds = parseInt(test[2])
          element.horaInicio = new Date().setHours(hour,minutes,seconds)
        } else {
          this.foo = (this.foo).toLocaleTimeString('en-US')
          let test = this.foo.split(":")
          let hour = parseInt(test[0]) 
          let minutes = parseInt(test[1])
          let seconds = parseInt(test[2].slice(0,2))
          element.horaInicio = new Date().setHours(hour,minutes,seconds)
        }

        let test2 = element.totalMin.split(":")
        let minutes2 = test2[0]

        let d1 = new Date (element.horaInicio),
        d2 = new Date(d1);
        let newDate = parseInt(d1.getMinutes()) + parseInt(minutes2) 
        element.horaFin = d2.setMinutes(newDate);
        this.foo =  new Date(element.horaFin);
      });


      this.arr = this.hora
 
      let counter = 0

      this.instructions.forEach(element => {
        let rest = element.tiempo
        let pulso = this.pulsos[counter].toString()
        // console.log(pulso)
        // console.log(counter)

        this.arr = this.arr.split(":")

        let hour = parseInt(this.arr[0])
        let minutes = parseInt(this.arr[1])
        let seconds = parseInt(this.arr[2].slice(0,2))

        let arr2 = pulso.split(".")
        let hour2 = 0
        let minutes2 = parseInt(arr2[0])
        let seconds2 = parseInt(arr2[1].slice(0,2))

        rest = rest.split(":")

        let hour3 = parseInt(rest[0])
        let minutes3 = parseInt(rest[1])
        let seconds3 = parseInt(rest[2].slice(0,2))

        let newHour = hour + hour2 + hour3
        let newMinutes = minutes + minutes2 + minutes3
        let newSeconds = seconds + seconds2 + seconds3


        // console.log(`${newHour} ${newMinutes} ${newSeconds}`)
        this.pulsosTime.push(
          new Date().setHours(hour,minutes,seconds)
        )

        this.pulsosTime2.push(
          new Date().setHours(newHour,newMinutes,newSeconds)
        )

        this.headers2.push(
          { text: 'P.', value: 'pulse' }
        )
        this.arr = new Date(new Date().setHours(newHour,newMinutes,newSeconds)).toLocaleTimeString('en-US')
        counter++
      });

    },
    close() {
      this.dialog = false
      this.headers2 = []
      this.pulsos = []
    },
    calcTotal() {
      this.total = 0
      this.instructions.forEach(element => {
        this.total += parseFloat(element.pulso) 
      });
    },
    save() {
      let txt;
      let r = confirm("CONFIRMAR INSTRUCCIÓN DE RIEGO!");
      if (r == true) {
        let project = {
          project: this.select
        }

        this.$axios.post("/api/DeleteIrrigationInstruction/", project).then(() => {
          this.sectors.forEach(element => {
            // console.log(element)
            element.project = this.select
            this.$axios.post("/api/IrrigationInstruction/", element)
          })
        })

        this.$axios.post("/api/DeletePulseInstruction/", project).then(() => {
          this.instructions.forEach(element => {
            element.project = this.select
            this.$axios.post("/api/PulseInstruction/", element)
          })
        })
        alert("INSTRUCCIÓN GUARDAD!")
      } else {
        txt = "INSTRUCCION CANCELADA!";
      }

 
    },
    deleteRowSector(index, invoice_product) {
        let idx = this.sectors.indexOf(invoice_product);
        if (idx > -1) {
            this.sectors.splice(idx, 1);
        }
        let newPulso = this.pulso/this.sectors.length
    },
    deleteRow(index, invoice_product) {
        let idx = this.instructions.indexOf(invoice_product);
        if (idx > -1) {
            this.instructions.splice(idx, 1);
        }
        let newPulso = this.pulso/this.instructions.length
      
        this.instructions.forEach(element => {
          element.pulso = newPulso
        });
    },
    addNewRow() {
      let index = this.instructions.length + 1
        this.instructions.push({
          index: index,
          pulso: '',
          tiempo: "00:00:00"
        });

      let newPulso = this.pulso/this.instructions.length
      
      this.instructions.forEach(element => {
        element.pulso = newPulso
      });
    },
    addNewSector() {
        let index = this.sectors.length + 1
        this.sectors.push({
          index: index
        });

      let newPulso = this.pulso/this.instructions.length
      
      this.instructions.forEach(element => {
        element.pulso = newPulso
      });
    },
    minTommss(minutes){
      let sign = minutes < 0 ? "-" : "";
      let min = Math.floor(Math.abs(minutes));
      let sec = Math.floor((Math.abs(minutes) * 60) % 60);
      return sign + (min < 10 ? "0" : "") + min + ":" + (sec < 10 ? "0" : "") + sec;
    },
    calcTime(date, time) {
      // console.log(time)
      let string = time.toString()
      // console.log(string)
      string = string.split(":")
      let hour = parseInt(string[0])
      let minutes = parseInt(string[1])
      let seconds = parseInt(string[2].slice(0,2))


      date.setHours(date.getHours() - hour)
      date.setMinutes(date.getMinutes() - minutes)
      date.setSeconds(date.getSeconds() - seconds); // timestamp
      date = new Date(date); // Date object
      // console.log(date);
      return date.toLocaleTimeString('en-US')
    }
}
}
</script>

<style lang="scss" scoped>
 

  #container {
    color: #616161 !important;
    margin-bottom: 10px;
    padding: 70px !important;
    border-radius: 5px;
  }

  #container2 {
    color: #616161 !important;
    margin-bottom: 10px;
    padding: 30px !important;
    border-radius: 5px;
    font-size:  30% !important;

    th, td {
      font-size: 40% !important;
    }
  }

  .dropdown {
    width: 150px;
  }


  .control {
    padding: 15px;
    width: auto !important;
    border: 2px solid gray !important;
    border-radius: 5px;
    margin-top: 0px !important;
  }

  input {
    background-color: rgba(190, 190, 190, .1);
    display: block !important;
    border: .5px solid lightgray !important;
    border-radius: 3px;
    padding: 8px;
    width: 90px;
  }

  .prompt {
    margin-top: 10px !important;
  }

  #myTime {
    width: 150px !important;
  }

  .head {
    width: 91px;
  }

  table {
    border-collapse: collapse;
  }

 th, td {
  text-align: left;
  width: 20px;
 }

 th {
   font-weight: bold;
 }

table, th, td {
  // font-size: 10px !important;
  // padding: 5px 5px !important;
  border: .5px solid rgb(182, 181, 181);
}



 .disable {
   background-color:  white;
 }

 .fa-plus-circle {
   margin-right:5px;
 }

 .add {
   margin-top: 35px !important;
   margin-left: -30% !important;
   margin-bottom: 30px;
   color: white !important;
 }


  .trashIconContainer {
    width: 50px;
  }

  .fa-trash-alt {
    cursor: pointer;
    margin-left: 40%;
  }

  .fa-table {
    margin-right: 6%;
  }

  .fa-file-upload {
    margin-right: 6%;
  }

  .tablebox {
    width: 91px;
  }

  .hidden {
    margin-top: -40px;
    margin-bottom: -60px;
    visibility: hidden;
  }

  .elevation-1 {
    font-size: 30px !important;
  }

  .hide {
    display: none;
  }

  .show {
    font-weight: bold;
    visibility: visible !important;
  }

  .totalTimeInfo {
    visibility: visible !important;
    max-width: 50px !important;
    font-size: 7px !important;
  }

  .timeInfo {
    visibility: visible !important;
    max-width: 50px !important;
    font-size: 7px !important;
  }

</style>